module.exports = __webpack_public_path__ + "static/media/tournaments_icon.d7b4952d.jpeg";